import {connect} from 'react-redux';
import * as LoginActions from '../../../actions/LoginActions';
import {withRouter} from 'react-router';
import NotEligibleStepView from '../../../components/views/mx/creditoReal/NotEligibleStepView';
import * as WizardMXActions from '../../../actions/WizardMXActions';

const mapStateToProps = state => ({

});

const mapDispatchToProps = (dispatch) => {
    return {
        onPressGotoHome: () => {
            dispatch(WizardMXActions.CLEAN_STATE_ONCE_FINISHED_LOAN.action());
            dispatch(WizardMXActions.CLEAN_STATE_ONCE_FINISHED_LOAN_TURBO_CASH.action());
            dispatch(WizardMXActions.GO_TO_HOME_ACTION.action());
        },
    };
};

const NotEligibleStepContainer = withRouter<any, any>(connect(
    mapStateToProps,
    mapDispatchToProps
)(NotEligibleStepView));

export default NotEligibleStepContainer;